import React from 'react';
import PropTypes from 'prop-types';

import AutoCheckoutEducation from './AutoCheckoutEducation';
import Modal from '../../Modal';
import './AutoCheckoutEducationModal.scss';

/**
 * The Auto Checkout Education Modal
 */
const AutoCheckoutEducationModal = React.forwardRef(
  ({ renderContainer, onCloseModal, ...props }, ref) => (
    <Modal
      ref={ref}
      initialOpen
      transitionOpen="slide-in-up"
      transitionClose="slide-out-down"
      onClose={onCloseModal}
      renderContainer={renderContainer}
      className="auto-checkout-education-modal"
      {...props}
    >
      <AutoCheckoutEducation />
    </Modal>
  ),
);

AutoCheckoutEducationModal.propTypes = {
  renderContainer: PropTypes.object,
  onCloseModal: PropTypes.func,
};

AutoCheckoutEducationModal.defaultProps = {
  renderContainer: null,
  onCloseModal: () => {},
};

export default AutoCheckoutEducationModal;
